import { CruiseSearchController } from 'src/common/controllers/cruise/search-controller';
export const cruise = [CruiseSearchController];